<template>
  <el-dialog
    :append-to-body="true"
    :title="type == 'add' ? '新增定期家访信息' : '修改定期家访信息'"
    :visible.sync="show"
    direction="ltr"
    :before-close="handleClose"
     width="800px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
    <div style="height:50vh;overflow-y: scroll;">

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="学生名称:" prop="studentName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.studentName"
          placeholder="请输入学生名称"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="班级名称:" prop="className">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.className"
          placeholder="请输入班级名称"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="家访类型 :" prop="visitType">
        <el-select
          style="width:95%"
          v-model="ruleForm.visitType"
          placeholder="请选择家访类型"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.homeVisitType"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="家访状态:" prop="visitStatus">
        <el-select
          :disabled="type == 'add' ? false : true"
          style="width:95%"
          v-model="ruleForm.visitStatus"
          placeholder="请选择家访状态"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.homeVisitStatus"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学生类型:" prop="studentType">
        <el-select
          style="width:95%"
          v-model="ruleForm.studentType"
          placeholder="请选择家访类型"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.studentTypeList"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="家长姓名:" prop="parentName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.parentName"
          placeholder="请输入家长姓名"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="家长联系方式:" prop="parentPhone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.parentPhone"
          placeholder="请输入家长联系方式"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="家庭地址:" prop="address">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.address"
          placeholder="请输入家庭地址"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="家访时间段:" prop="time">
        <el-date-picker
          v-model="ruleForm.time"
          size="mini"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          style="width:95%"
        ></el-date-picker>
        <!-- <el-input
          style="width:95%"
          v-model.trim="ruleForm.visitTime"
          placeholder="请输入家访时间段"
          clearable
          size="small"
        ></el-input> -->
      </el-form-item>
       <el-form-item label="家访老师姓名:" prop="teacherName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.teacherName"
          placeholder="请输入家访老师姓名"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
       <el-form-item label="老师联系电话:" prop="teacherPhone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.teacherPhone"
          placeholder="请输入老师联系电话"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
       <el-form-item label="学生基本情况:" prop="studentContent">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.studentContent"
          placeholder="请输入学生基本情况"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
       <el-form-item label="家访内容:" prop="visitContent">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.visitContent"
          placeholder="请输入家访内容"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      
    </el-form>
    </div>
    <span slot="footer" size="large">
        <el-button type="primary" size="small" @click="saveForm('ruleForm')"
        v-loading="saveLoading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="saveLoading">取消</el-button>
      </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'AddOrEditVisit',
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false,
      },
    },
    drawerType: {
      type: String,
      default: {
        return: '',
      },
    },
    initialData: {
      type: Object,
      default: {
        return: {},
      },
    },
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(' '))
      } else if (!reg.test(value)) {
        callback(new Error(' '))
      } else {
        callback()
      }
    }
    return {
        pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      show: false,
      type:'',
      ruleForm: {
          id:'',
        studentName: '',//学生名称
        className:'',//班级名称
        visitType:0,//家访类型
        visitStatus:0,//家访状态
        studentType:0,//学生类型
        parentName:'',//家长姓名
        parentPhone:'',//家长联系方式
        address:'',//家庭地址
        time:[],
        visitTime:'',//家访时间段（例子2020-11-13 ~ 2020-11-13）
        teacherName:'',//家访老师姓名
        teacherPhone:'',//老师联系电话
        studentContent:'',//学生基本情况 (学业、品质、特长、家庭等)
        visitContent:'',//家访内容
        schoolId:this.$store.state.schoolId
      },
      saveLoading:false,
      rules: {
        studentName: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        className: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        visitType: [
          { required: true, message: ' ', trigger: 'change' },
        ],
         visitStatus: [
          { required: true, message: ' ', trigger: 'change' },
        ],
         studentType: [
          { required: true, message: ' ', trigger: 'change' },
        ],
        parentName: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        parentPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' },
        ],
        address: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        time: [
          { required: true, message: ' ', trigger: 'change' },
        ],
        teacherName: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        teacherPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' },
        ],
        studentContent: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        visitContent: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {},
  methods: {
    //   关闭抽屉
    handleClose() {
      this.$emit('handleClose')
    },
    saveForm(formName){
        this.$refs[formName].validate((valid) => {
        if (valid) {
            this.addOrEditForm()
        } else {
          return false
        }
      })
    },
    async addOrEditForm(){
    this.saveLoading = true
      let req = Object.assign({}, this.ruleForm)
      req.happenTime = parseInt(req.happenTime) / 1000
      if (this.type == 'add') {
            delete req.id
        }
    if (req.time) {
          req.visitTime = req.time.join(" ~ ");
          delete req.time
      }
      let res = await this.$Http.addOrEditHomeVisits(req,true)
      this.saveLoading = false
      if (res.code == 200) {
          this.$emit('saveData')
      } else {
          this.$message({
          message: res.messsage || '提交失败',
          type: 'error',
        })
      }
    },
  },
  watch: {
    drawerShow: function(nval) {
      this.show = nval
      if (nval) {
        this.type = this.drawerType || ''
        this.ruleForm = Object.assign({}, this.initialData)
      } else {
        this.$refs.ruleForm.resetFields()
      }
    },
  },
}
</script>
